import { render, staticRenderFns } from "./ModalOrdenesComponent.vue?vue&type=template&id=33c33402"
import script from "./ModalOrdenesComponent.vue?vue&type=script&lang=js"
export * from "./ModalOrdenesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports